<template>
  <div class="prepare" @click="hiddenMenu">
    <k-header :headerData="headerData">
    </k-header>
    <drag :options="optionData" class="dragwrap">
      <div class="work" slot='uLeft'>
        <div class="courseListW">
        <course-list :courseListData="courseListData" :isShow="showStatus" @changeLang="changeLang" @saveAll="saveAll"></course-list>  
        </div>
        <div class="paginaion-wrap">
          <pagination :total="totalCount" :current-page='current' @pagechange="pagechange"></pagination>
        </div>
      </div>
      <div class="work editor" slot='uRight'>
        <editor-mirror ref="codeEditor"></editor-mirror>
      </div>
      <div class="work iterm" slot='dLeft'>
        <div class="iterm-w" v-if="languageId =='35'">
          <browser :options="browserOption" :code="editorContent" @insertCodeSnippet="insertData"></browser>          
        </div>
        <div class="iterm-w" v-else>
          <iterm isCompile="1" :options="itermData" :tab="tab" :inputParam="inputParam" :compileInfo="compileInfo" @insertTemplate="insertBackData"></iterm> 
        </div>
      </div>
    </drag>
    <div class="joinTip" v-show="showTip">
      <div class="tipPanel">
        <div class="tipTitle">
          <span style="">提示</span>
          <span class="el-icon-close" @click="closeTip"></span>
        </div>
        <div class="tipBody">
            <span class="joinWay">确认要删除本节课程吗？</span>
        </div>
        <div class="tipFooter">
          <span :class="{active: isdelete}" @click="closeTip">取消</span>          
          <span :class="{active: !isdelete}" @click="deletItemData">确认</span>
        </div>
      </div>
    </div>
    <transition name="fade" v-on:after-enter="afterEnter">
      <div v-if="saved"  class="saved">
        已保存
      </div>      
    </transition>  
  </div>
</template>

<script>
/* eslint-disable */
import Drag from '@/components/Drag'
import EditorMirror from '@/components/Editor/editor'
import kHeader from '@/components/Header'
import CourseList from '@/components/CourseList'
import { HYBIRD_URL } from '@/config/url_config'
import { ajaxAPI } from '@/utils/ajaxUtil'
import { insertLibrary, insertTemplate, getFileName, exportFile } from '@/utils/utils'
import Iterm from '@/components/ItermV2'
import Browser from '@/components/Browser'
import EventBus from '@/views/eventBus'
import pagination from '@/components/pagination'
export default{
  components: {
    Drag,
    EditorMirror,
    kHeader,
    CourseList,
    Iterm,
    Browser,
    pagination
  },
  data() {
    return {
      languageId: this.$route.params.languageId,
      accessToken: window.localStorage.getItem('accessToken'),
      optionData: {
        layout: 'r-2l'
      },
      headerData: {
        role: '备课',
        roomId: this.$route.params.roomId
      },
      dropDown: false,
      choosIndex: '0',
      isHand: true,
      courseListData: [],
      courseData: {},
      configData: {
        isCompile: true,
        role: 0
      },
      itermData: {
        isCompile: true,
        isLive: false
      },
      tab: 0,
      inputParam: '',
      compileInfo: {},
      roomInfo: {},
      courseName: '',
      browserOption: {
        role: 1
      },
      editorContent: '',
      isdelete: '',
      showTip: '',
      courseId: '',
      indexData: '',
      flag: '',
      pgSize: 3,
      pgCount: '',
      pgList: [],
      currentPg: 1,
      showMoreTail: '',
      showPgOne: '',
      firstPage: '',
      lastPage: true,
      jumpPg: 1,
      saved: '',
      totalCount: 0,    // 记录总条数
      display: 10,        // 每页显示条数
      current: 1,          // 当前的页数
      showStatus: false
    }
  },
  created() {
  },
  mounted() {
    console.log('this is current editor object', this.languageId)
    console.log('this is current editor object', this.codeEditor)

    document.getElementsByTagName('title')[0].innerHTML = '备课'

    let _this = this

    this.getCourseList()
    // 添加章节
    EventBus.$on('createChapter', function () {
      let url = `${HYBIRD_URL}/programming/room/teacherCourse/save/api?access_token=${_this.accessToken}`
      let data = {
        roomId: _this.$route.params.roomId,
        languageId: _this.languageId,
        courseName: '未命名课程',
        courseContent: ''
      }
      ajaxAPI('POST', url, data).then(data => {
        console.log('12345678', data)
        if (data.data.status === '0') {
          data.data.data.saveStatus = true
          _this.currentPg = 1
          _this.getCourseList()
        }
      })
    })

    EventBus.$on('showCourseCode', function (code, index) {
      console.log('code', code)
      console.log('index', index)
      _this.flag = code
      _this.choosIndex = index
      _this.codeEditor.setValue(code)
    })

    EventBus.$on('updateChapter', function (data, index) {
      console.log(data)
      let url = `${HYBIRD_URL}/programming/room/teacherCourse/update/api?access_token=${_this.accessToken}`
      ajaxAPI('PUT', url, data).then(data => {
        console.log(data)
        _this.courseListData[index].saveStatus = true
        _this.saved = true
      })
    })

    EventBus.$on('deleteChapter', function (courseId, index) {
      _this.showTip = true
      _this.courseId = courseId
      _this.indexData = index
      // _this.jumpPage()
    })

    EventBus.$on('showMenu', function (status) {
      console.log('----', status)
      _this.showStatus = status
    })

    EventBus.$on('exportItem', function (data) {
      let fileName = getFileName(data.languageId, data.courseName)
      exportFile(data.courseContent, fileName)
    })

    this.codeEditor.on('change', function(instance) {
      let code = instance.getValue()
      if (code !== _this.flag) {
        _this.courseListData[_this.choosIndex].saveStatus = false
        _this.courseListData[_this.choosIndex].courseContent = code
      }
      _this.$store.commit('addAction', instance.getValue())
      _this.editorContent = instance.getValue()
      // _this.courseListData[_this.choosIndex].courseContent = code
    })
    window.onbeforeunload = function (e) {
      return '确认退出？ 将不保存你的更改'
    }
  },
  methods: {
    hiddenMenu() {
      console.log('===')
      this.showStatus = false
      // EventBus.$emit('showMenu')
    },
    getCourseList(page) {
      console.log('page')
      let url = `${HYBIRD_URL}/programming/room/teacherCourseList/api?page=1&pageSize=10&roomId=${this.headerData.roomId}&languageId=${this.languageId}&access_token=${this.accessToken}`
      console.log(url)
      ajaxAPI('GET', url).then(datas => {
        console.log(datas)
        this.totalCount = parseInt(datas.data.data.totalCount)
        this.setCourseListData(datas.data.data.list)
      })
    },
    setCourseListData (data) {
      // this.courseData = this.$store.state.courseData
      sessionStorage.setItem('COURSE', JSON.stringify(data))
      for (var i = 0; i < data.length; i++) {
        data[i].saveStatus = true
      }
      if (data.length === 0) {
        this.courseListData = []
        this.codeEditor.setValue('', 'end')
        this.$store.state.courseId = ''
      } else {
        this.courseListData = data
        console.log('courseListData', data)
        this.flag = this.courseListData[0].courseContent
        this.codeEditor.setValue(this.courseListData[0].courseContent, 'end')
        this.$store.state.courseId = this.courseListData[0].courseId
      }
    },
    deletItemData () {
      let _this = this
      _this.showTip = ''
      let courseId = _this.courseId
      console.log(courseId)
      console.log(_this.accessToken)
      let url = `${HYBIRD_URL}/programming/room/teacherCourse/remove/api?courseId=${courseId}&access_token=${this.accessToken}`
      ajaxAPI('Delete', url).then(data => {
        if (data.data.status === '0') {
          _this.courseListData.splice(_this.indexData, 1)
          if (_this.courseListData.length === 0) {
            if (this.totalCount === 1) {
              _this.codeEditor.setValue('', 'end')
              return false
            } else if (_this.currentPg === _this.pgCount) {
              _this.currentPg = _this.currentPg - 1
            }
          }
          _this.currentPg = 1
          _this.getCourseList()
        }
      })
    },
    changeName (data) {
      console.log(data)
      this.courseName = data
    },
    insertData(index) {
      console.log('index', index)
      let editor = this.codeEditor
      insertLibrary(index, editor)
    },
    closeTip() {
      this.showTip = ''
    },
    changeLang(data) {
      this.languageId = data
      this.showStatus = false
      this.$router.push({name: 'Prepare', params: {roomId: this.$route.params.roomId, languageId: this.languageId}})
      console.log('testingggggggg', this.$route.params.languageId)
      this.getCourseList()
    },
    pagechange(currentPage) {
      console.log(currentPage)
      let url = `${HYBIRD_URL}/programming/room/teacherCourseList/api?page=${currentPage}&pageSize=10&roomId=${this.headerData.roomId}&languageId=${this.languageId}&access_token=${this.accessToken}`
      ajaxAPI('GET', url).then(data => {
        console.log(data)
        this.setCourseListData(data.data.data.list)
      })
    },
    saveAll() {
      console.log(this.courseListData)
      let _this = this
      let url = `${HYBIRD_URL}/programming/room/teacherCourse/update/api?access_token=${_this.accessToken}`
      for (let i = 0, len = this.courseListData.length; i < len; i++) {
        console.log(this.courseListData)
        if (!this.courseListData[i].saveStatus) {
          ajaxAPI('PUT', url, this.courseListData[i]).then(data => {
            console.log(i, data)
            _this.courseListData[i].saveStatus = true
          })
        }
      }
      _this.saved = true
    },
    afterEnter() {
      let _this = this
      setTimeout(function () {
        _this.saved = ''
      }, 1000)
    },
    insertBackData(language) {
      insertTemplate(language, this.codeEditor)
    }
  },
  computed: {
    codeEditor() {
      return this.$refs.codeEditor.editor
    }
  }
}
</script>

<style lang="scss">
  .prepare{
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;

    .dragwrap{
      width: 100%;
      height: calc(100% - 48px);
      background-color: #999;

      .item{
        border-right: 2px solid #1FB6FF;
      }
    }

    .work{
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-right: 2px solid #1FB6FF;

      .courseListW{
        height: calc(100% - 48px);
      }

      .paginaion{
        height:28px;
        background: #fff;
        display: flex;

        .c-width{
          margin: 0 auto;

          .page-icon{
            border: 1px solid #1FB6FF;
            box-sizing: border-box;
            display: inline-block;
            border-radius: 2px;
            width: 24px;
            height: 24px;
            font-size: 8px;
            line-height: 24px;
            text-align: center;
            cursor: pointer;
            color: #1FB6FF;
          }
          
          .pgNumberW{
            display:inline-block;
            vertical-align: top;
            .pgNumber{
              display:flex;
              position: relative;
              color: #1FB6FF;

              li{
                border-radius: 2px;              
                width: 24px;
                line-height: 24px;
                text-align: center
              }
              
              .lastPage{
                margin-left: 24px;
              }
              .firstPage{
                margin-right: 24px;
              }
              .pgActive{
                background: #1FB6FF;
                color: #fff;
                box-shadow: 0 5px 6px -3px #1FB6FF;
              }
              .showMoreTailL{
                position: absolute;
                right: 24px;
              }
              .showMoreTailF{
                position: absolute;
                left: 24px;
              }
            }
          }
          .jump{
            input{
              width: 20px
            }
          }
        }
      }
    }
    .web-iterm{
      border: 1px solid #40b5ff;
    }
    .iterm-w{
      height:100%;
    }
    .saved{
      position: absolute;
      top: 50%;
      left: 50%;
      width: 220px;
      background: rgba(104, 129, 153, .9);
      border-radius: 8px;
      box-shadow: 0 0 20px #7996B3;
      text-align: center;
      line-height: 60px;
      color: #fff;
      letter-spacing: 4px;
      font-size: 16px;
    }
    .joinTip{
      position: absolute;
      top:0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 99999;

      .tipPanel{
        width:360px;
        height:240px;
        position: absolute;
        background-color: #FFF;
        top: 15%;
        left: 50%;
        transform: translate(-50%);
        font-weight: normal;

        .tipTitle{
          height:39px;
          padding: 10px 30px;
          border-bottom: 1px solid rgba(209, 211, 212, .4);
          line-height:39px;
          text-align: left;
          color:#D1D3D4;
          display:flex;
          justify-content:space-between;
          font-size: 16px;

          span:first-child{
            color: #22B8FF;
            letter-spacing: 10px;
            font-size: 20px
          }
            
          .el-icon-close{
            position: relative;
          }
          .el-icon-close:before{
            position: absolute;
            top: 50%;
            transform: translate(-50%,-50%); 
          }      
        }
        .tipBody{
          margin:48px auto;
          color: #8B9194;
          text-align: center;
          
          .joinWay{
            color: #8B9194;
            font-size: 16pxpx;
          }
        }
        .tipFooter{
          height:39px;
          padding: 15.5px 30px;
          border-top: 1px solid rgba(209, 211, 212, .4);

          span{
            float:right;
            color: rgb(34, 184, 255);
            width: 70px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            list-style: none;
            margin-right: 2px;
            cursor: pointer;
            font-weight: 400;
          }
          span:hover{
            color: #FFF;
            background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
            transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
            box-shadow: 0px 0px 2px 0px #B3E5FF;
            border: none;
            border-radius: 30px;        
          }
          .active{
            color: #FFF;
            background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
            transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
            box-shadow: 0px 0px 2px 0px #B3E5FF;
            border: none;
            border-radius: 30px;
          }
        }
      }
    } 
  }
</style>



// WEBPACK FOOTER //
// prepare.vue?a8678158